<template>
    <v-container id="selectormatriculado-caplp">
      <v-row>
        <v-col cols="2" md="2" lg="2">
          <v-text-field
            v-model="dni"
            label="DNI"
            height="20px"
            v-on:keyup.enter="BuscarAlumno"
            :disabled= "habilitado!=null ? habilitado : false"
          />
        </v-col>
        <v-col cols="5" md="7" lg="7">
          <v-text-field
            v-model="alumno"
            label="Alumno"
            height="20px"
            v-on:keyup.enter="BuscarAlumno"
            :disabled= "habilitado!=null ? habilitado : false"
          />
        </v-col>
        <v-col cols="4" md="2" lg="2">
          <v-btn
            class="ma-2"
            fab
            dark
            x-small
            color="primary"
            title="Buscar"
            @click="BuscarAlumno"
            :disabled= "habilitado!=null ? habilitado : false"
          >
            <v-icon
              dark
            >
              mdi-magnify
            </v-icon>
          </v-btn>
          <v-btn
            class="ma-2"
            fab
            dark
            x-small
            color="primary"
            title="Quitar Filtro Alumno"
            @click="QuitarAlumno"
            :disabled= "habilitado!=null ? habilitado : false"
          >
            <v-icon
              dark
            >
              mdi-cancel
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-dialog v-model="dialogmensaje" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">
            {{ mensajetitulo }}
          </v-card-title>
          <v-card-text>
            {{ mensajecuerpo }}
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="green darken-1" text @click="dialogmensaje = false">
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="loading" full-width>
        <v-container
          fluid
          class="full-height"
          style="background-color: rgba(255, 255, 255, 0.5)"
        >
          <v-row
            align="center"
            justify="center"
            style="height: 100vh"
            no-gutters
            dense
          >
            <v-col class="elementocentrado">
              <v-progress-circular indeterminate color="primary" />
            </v-col>
          </v-row>
        </v-container>
      </v-dialog>
      <v-dialog v-model="dialogselalumno" persistent max-width="950">
        <v-card>
          <v-card-title class="headline">
            Seleccione Alumno
          </v-card-title>
          <v-card-actions>
            <v-btn color="red darken-1" text @click="dialogselalumno = false">
              Cerrar
            </v-btn>
          </v-card-actions>
          <v-card-text>
            <v-data-table
              :headers="columnas"
              :items="lista"
              :items-per-page="10"
              :footer-props="{'items-per-page-text': 'Filas por Página:',
                              'items-per-page-all-text' : 'Todos'}"
              class="elevation-1"
              dense
              no-data-text="Sin Registros"
              multi-sort
              >
              <template v-slot:item.actions="{ item }">
                <v-icon
                  small
                  class="mr-2"
                  @click="seleccionarAlumno(item)"
                >
                  mdi-arrow-right
                </v-icon>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </template>
  <script>
    import axios from '@/axios'
    export default {
      props: ['idseleccionado', 'nivel', 'habilitado'],
      data() {
        return {
          loading: false,
          dialogmensaje: false,
          mensajetitulo: '',
          mensajecuerpo: '',
          dni: '',
          alumno: '',
          lista: [],
          dialogselalumno: false,
          columnas: [
            {
              text: 'Op.',
              align: 'center',
              value: 'actions',
              sortable: false,
              width: 100
            },
            {
              text: 'ID',
              align: 'center',
              sortable: true,
              value: 'idpersona',
              width: 15
            },
            {
              text: 'Apellido',
              align: 'center',
              sortable: true,
              value: 'apellido',
              width: 220
            },
            {
              text: 'Nombre',
              align: 'center',
              sortable: true,
              value: 'nombre',
              width: 220
            },
            {
              text: 'N° Matriculado',
              align: 'center',
              sortable: true,
              value: 'nromatriculadosisant',
              width: 150
            },
            {
              text: 'Documento',
              align: 'center',
              sortable: true,
              value: 'nrodoc',
              width: 150
            },
            {
              text: 'Fecha Nacim',
              align: 'left',
              sortable: true,
              value: 'fecnac',
              width: 150
            }
          ],
          //idsel: 0
        }
      },
      mounted() {
        this.dni='';
        this.alumno='';
        if(this.idseleccionado!=null && this.idseleccionado!=0){
          this.BuscarAlumno();
        }
      },
      methods: {
        MostrarMensaje(titulo, cuerpo) {
          this.mensajetitulo = titulo;
          this.mensajecuerpo = cuerpo;
          this.dialogmensaje = true;
        },
        BuscarAlumno (){
          this.loading = true
          var alu= this.alumno!='' ? this.alumno : ' '
          var dni= this.dni!='' ? + this.dni : '0'
          var idper= this.idseleccionado!=null && this.idseleccionado!=0 ? this.idseleccionado : '0';
          var nivel= this.nivel!=null && this.nivel!=0 ? this.nivel : '0';
          axios.get('alumno/selectoralumno/' + dni + '/' + alu + '/' + idper + '/' + nivel)
            .then((result) => {
              if(result.data.resultado===0){
                this.lista = result.data.datos;
                if(this.lista.length===0)
                {
                    this.QuitarAlumno();
                    this.MostrarMensaje('Atención','No existen alumnos con los criterios seleccionados!!!')
                }
                else if(this.lista.length===1)
                {
                    /*trae matriculado*/
                    this.dni= this.lista[0].nrodoc;
                    this.alumno= this.lista[0].apellido + ' ' + this.lista[0].nombre;
                    this.$emit('selAlumno', this.lista[0]);
                }else{
                    /*abre cuadro con lista para seleccionar*/
                    this.dialogselalumno=true
                }
                this.loading = false
              }else{
                this.QuitarAlumno();
                this.loading = false
                this.MostrarMensaje('Error', result.data.resultadomensaje)
              }
            })
            .catch((error) => {
              this.QuitarAlumno();
              this.loading = false
              this.MostrarMensaje('Error', error)
            })
        },
        QuitarAlumno () {
          this.dni=''
          this.alumno=''
          this.lista=[]
          this.idseleccionado=0;
          this.$emit('selAlumno', null)
        },
        seleccionarAlumno (item) {
          this.loading=true;
          this.dni= item.nrodoc;
          this.alumno= item.apellido + ' ' + item.nombre;
          this.$emit('selAlumno', item);
          this.dialogselalumno=false;
          this.loading=false;
        }
      }
    };
  </script>
  <style>
    .textocentrado {
      text-align: center;
    }
    .elementocentrado {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .col-xl,
    .col-xl-auto,
    .col-xl-12,
    .col-xl-11,
    .col-xl-10,
    .col-xl-9,
    .col-xl-8,
    .col-xl-7,
    .col-xl-6,
    .col-xl-5,
    .col-xl-4,
    .col-xl-3,
    .col-xl-2,
    .col-xl-1,
    .col-lg,
    .col-lg-auto,
    .col-lg-12,
    .col-lg-11,
    .col-lg-10,
    .col-lg-9,
    .col-lg-8,
    .col-lg-7,
    .col-lg-6,
    .col-lg-5,
    .col-lg-4,
    .col-lg-3,
    .col-lg-2,
    .col-lg-1,
    .col-md,
    .col-md-auto,
    .col-md-12,
    .col-md-11,
    .col-md-10,
    .col-md-9,
    .col-md-8,
    .col-md-7,
    .col-md-6,
    .col-md-5,
    .col-md-4,
    .col-md-3,
    .col-md-2,
    .col-md-1,
    .col-sm,
    .col-sm-auto,
    .col-sm-12,
    .col-sm-11,
    .col-sm-10,
    .col-sm-9,
    .col-sm-8,
    .col-sm-7,
    .col-sm-6,
    .col-sm-5,
    .col-sm-4,
    .col-sm-3,
    .col-sm-2,
    .col-sm-1,
    .col,
    .col-auto,
    .col-12,
    .col-11,
    .col-10,
    .col-9,
    .col-8,
    .col-7,
    .col-6,
    .col-5,
    .col-4,
    .col-3,
    .col-2,
    .col-1 {
      padding: 2px !important;
    }
    @media only screen and (min-width: 960px) {
      .altojusto {
        height: 45px !important;
      }
    }
    .alineaizquierda {
      text-align: left !important;
    }
    .alineacentro {
      text-align: center;
    }
    .alineaderecha {
      text-align: right;
    }
    .ocupa10 {
      width: 10%;
    }
    .ocupa20 {
      width: 20%;
    }
    .ocupa30 {
      width: 30%;
    }
    .ocupa50 {
      width: 50%;
    }
    .ocupa75 {
      width: 75%;
    }
    .ocupa95 {
      width: 95%;
    }
    .centradovertical {
      vertical-align: middle;
      align-items: center;
    }
    .abajovertical {
      vertical-align: bottom;
    }
    .TituloGrilla {
      font-family: Tahoma;
      font-size: medium;
      font-weight: bold;
      background-color: darkgray;
    }
    .textoNegritaRojo {
      color:red !important;
      font-weight:bold !important;
    }
    .textoNegritaVerde{
      color:rgb(83, 248, 125) !important;
      font-weight:bold !important;
    }
  </style>